'use strict';

export class BlockProfessionalDevelopmentProgress {
  constructor() {
    var block = $("#block-views-block-professional-development-progress");
    if (block.length < 1) return;
    var pd = block.find('.my-professional-development-progress');
    var meta = pd.find('.meta').data();
    var self = this;

    // $.ajax({
    //   url: meta.src,
    //   success: function (response) {
    //     pd.append(self.processTemplate(response));
    //   },
    //   error: function (xhr, error) {

    //   }
    // });

    pd.append(self.processTemplate({}));

    
  }

  currentLevelText(completed) {
    if (completed <= 30) return "Off to a good start!";

    if (completed <= 60) return "Midway";

    if (completed >= 60 && completed < 100) return "Almost there";

    return "Completed";
  }

  processTemplate(data) {
    var template = $(`
      <div class="professional-development-progress">
        <div class="current-level">
          <h4 class="current-level-text"></h4>
          <div class="achievment">
            <h4 class="achievment-value"></h4>
            <div class="achievment-label">Activities / classes completed</div>
          </div>
        </div>
        <div class="progress-bar">
          <div class="progress">
            <div class="progress-value"></div>
          </div>
          <div class="progress-milestone">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="progress-date-wrapper">
          <div class="progress-date start">
            <div class="date-label">Start</div>
            <div class="date-value"></div>
          </div>
          <div class="progress-date end">
            <div class="date-label">End</div>
            <div class="date-value"></div>
          </div>
        </div>
      </div>
  `);

    template.find('.current-level-text').html(this.currentLevelText(100));
    template.find('.achievment .achievment-value').html('3/12');
    setTimeout(function () {
      template.find('.progress-value').css('width', '30%');
    }, 1000);
    template.find('.progress-date.start .date-value').html('20 July 2021');
    template.find('.progress-date.end .date-value').html('20 July 2023');
    return template;
  }
}
